import React, { useEffect, useLayoutEffect } from "react";
import { BrowserRouter, Route, Routes, Outlet, HashRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store";
import Sidebar from "./components/layout/Sidebar";

import AdminSignIn from "./components/auth/AdminSignIn";
import AdminProtectedRoute from "./routes/AdminProtectedRoute";
import AdminPublicRoute from "./routes/AdminPublicRoute";
import AdminSidebar from "./components/layout/AdminSidebar";
import SendEmail from "./components/admin/SendEmail";
import SignUp from "./components/auth/SignUp";
import Otp from "./components/auth/Otp";
import Setting from "./components/admin/Setting";
import Dashbaord from "./components/admin/Dashbaord";
import History from "./components/admin/History";


const App = () => {

    const SidebarLayout = () => (
        <Sidebar>
            <Outlet />
        </Sidebar>
    );

    const AdminSidebarLayout = () => (
        <AdminSidebar>
            <Outlet />
        </AdminSidebar>
    );

    return (
        <Provider store={store}>
            <HashRouter>
                <Routes>
                   

                    <Route element={<AdminSidebarLayout />}>

                        <Route
                            path="/dashboard"
                            element={
                                <AdminProtectedRoute>
                                    <Dashbaord />
                                </AdminProtectedRoute>
                            }
                        />
                         <Route
                            path="/sendEmail"
                            element={
                                <AdminProtectedRoute>
                                    <SendEmail />
                                </AdminProtectedRoute>
                            }
                        />
                        <Route
                            path="/history"
                            element={
                                <AdminProtectedRoute>
                                    <History />
                                </AdminProtectedRoute>
                            }
                        />
                        <Route
                            path="/setting"
                            element={
                                <AdminProtectedRoute>
                                    <Setting />
                                </AdminProtectedRoute>
                            }
                        />

                      

                       

                   
                   

                    </Route>

                  

                  
                    <Route
                        path="/"
                        element={
                            <AdminPublicRoute>
                                <AdminSignIn />
                            </AdminPublicRoute>
                        }
                    />
                   
                    <Route
                        path="/signin"
                        element={
                            <AdminPublicRoute>
                                <AdminSignIn />
                            </AdminPublicRoute>
                        }
                    />
                     <Route
                        path="/otp-verification"
                        element={
                            <AdminPublicRoute>
                                <Otp />
                            </AdminPublicRoute>
                        }
                    />
 
 <Route
                        path="/signup"
                        element={
                            <AdminPublicRoute>
                                <SignUp />
                            </AdminPublicRoute>
                        }
                    />

                   
                </Routes>
            </HashRouter>
        </Provider>
    );
};

export default App;
